import { render } from "./confirmReviewPromotion.vue?vue&type=template&id=37924c86&scoped=true"
import script from "./confirmReviewPromotion.vue?vue&type=script&lang=js"
export * from "./confirmReviewPromotion.vue?vue&type=script&lang=js"

import "./confirmReviewPromotion.vue?vue&type=style&index=0&id=37924c86&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37924c86"]])

export default __exports__